import ClaimsServices from './ClaimsServices';
import ClaimsServicesMock from './ClaimsServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? ClaimsServicesMock : ClaimsServices;
